// src/pages/ConferirDocumento/index.js
import React, { useState } from 'react';
import { useConferencias } from './hooks/useConferencias';
import { useConferirDocumento } from './hooks/useConferirDocumento';
import FormSection from './components/FormSection';
import ConferenciasTable from './components/ConferenciasTable';
import AnaliseDialog from './components/AnaliseDialog';
import './ConferirDocumento.css';

const ConferirDocumento = () => {
  const { conferencias, loading: loadingConferencias, recarregar } = useConferencias();
  const [dialogAnalise, setDialogAnalise] = useState({
    isOpen: false,
    conferencia: null
  });

  // Callback após sucesso na conferência
  const handleConferenciaSuccess = (conferenciaData) => {
    // Recarregar lista
    recarregar();
    
    // Abrir dialog automaticamente com o resultado
    setDialogAnalise({
      isOpen: true,
      conferencia: conferenciaData
    });
  };

  const {
    arquivo,
    tipoAnalise,
    loading: loadingSubmit,
    error,
    setTipoAnalise,
    handleFileChange,
    handleRemoverArquivo,
    handleEnviar
  } = useConferirDocumento(handleConferenciaSuccess);

  const abrirAnalise = (conferencia) => {
    setDialogAnalise({
      isOpen: true,
      conferencia: conferencia
    });
  };

  const fecharDialog = () => {
    setDialogAnalise({
      isOpen: false,
      conferencia: null
    });
  };

  return (
    <div className="conferir-documento-container">
      {/* Header */}
      <div className="conferir-documento-header">
        <h2>✅ Conferência de Documentos Jurídicos</h2>
        <p>Esta função também está disponível enviando o ficheiro para conferir@jrrobot.pt - Ambas análises serão retornadas por e-mail.</p>
      </div>

      {/* Formulário de Conferência */}
      <FormSection
        tipoAnalise={tipoAnalise}
        setTipoAnalise={setTipoAnalise}
        arquivo={arquivo}
        onFileChange={handleFileChange}
        onRemoverArquivo={handleRemoverArquivo}
        onEnviar={handleEnviar}
        loading={loadingSubmit}
        error={error}
      />

      {/* Lista de Conferências Realizadas */}
      <ConferenciasTable
        conferencias={conferencias}
        loading={loadingConferencias}
        onVerAnalise={abrirAnalise}
      />

      {/* Dialog de Análise Completa (COM MARKDOWN) */}
      <AnaliseDialog
        isOpen={dialogAnalise.isOpen}
        conferencia={dialogAnalise.conferencia}
        onClose={fecharDialog}
      />
    </div>
  );
};

export default ConferirDocumento;